var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loginFromIcon[_vm.type])?_c('span',{staticClass:"login-from-icon webkit-no-drag",class:_vm.loginFromIcon[_vm.type].className,attrs:{"title":_vm.loginFromIcon[_vm.type].title}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }